import { render, staticRenderFns } from "./HandlesList.vue?vue&type=template&id=d32e7a94&"
import script from "./HandlesList.vue?vue&type=script&lang=js&"
export * from "./HandlesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports